import { Search, X } from 'lucide-react';

/** Rounded search field with a leading icon and a clear affordance. */
export default function SearchInput({
  value,
  onChange,
  placeholder = 'Search conversations',
}) {
  return (
    <div className="relative">
      <Search
        size={15}
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-ink-3"
      />
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        // 16px below md: any smaller and iOS Safari zooms the page on focus.
        className="h-10 w-full rounded-xl border border-line bg-surface pr-9 pl-9 text-[16px] text-ink transition placeholder:text-ink-3 focus:border-brand-500 focus:ring-4 focus:ring-brand-500/10 focus:outline-none md:text-[13px]"
      />
      {value !== '' && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="absolute top-1/2 right-2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-lg text-ink-3 transition hover:bg-surface-3 hover:text-ink"
        >
          <X size={13} />
        </button>
      )}
    </div>
  );
}
